import type { IconSvgObject } from './types';

const Medal02Icon: IconSvgObject = [
  ["path", { d: "M21 8V3H3V8L12 12L21 8Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M8 5.5V6.5M12 5.5V8M16 5.5V6.5", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M8.90984 21L12 19.3631L15.0902 21L14.4 17.713L17 15.4377L13.4833 15.0431L12 12L10.5167 15.0431L7 15.4377L9.6 17.713L8.90984 21Z", stroke: "currentColor", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }]
];

export default Medal02Icon;
